// src/components/FilteredItemsRenderer.jsx
import { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import ItemCard from "./SearchModal/ItemCard";

const FilteredItemsRenderer = ({ rootId, items, totalItemsCount }) => {
 const rootRef = useRef(null);

 useEffect(() => {
  const domNode = document.getElementById(rootId);
  if (domNode) {
   if (!rootRef.current) {
    rootRef.current = createRoot(domNode);
   }
   rootRef.current.render(
    <>
     {items.map((item) => (
      <ItemCard key={item.id} props={item} className="--card-filtered" />
     ))}
    </>
   );

   const matchingCountElement = document.getElementById(`item_matching_count_filtered_${rootId}`);
   const totalItemsCountElement = document.getElementById(`item_matching_count_all_${rootId}`);
   if (matchingCountElement) {
    matchingCountElement.textContent = items.length;
   }
   if (totalItemsCountElement) {
    totalItemsCountElement.textContent = totalItemsCount;
   }
  } else {
   console.warn(`DOM node with id ${rootId} not found`);
  }
 }, [rootId, items, totalItemsCount]);

 return null;
};

export default FilteredItemsRenderer;
